import React, { useState } from "react";
import { Modal, Table, Spin, Alert, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { removeDocument } from "../../api/api";

interface RemoveDocumentModalProps {
  show: boolean;
  onHide: () => void;
  document: {
    id: string;
    title: string;
    dateModified: string;
    status: string;
    metadata?: { key: string; value: string }[];
    user: string;
  };
}

const RemoveDocumentModal: React.FC<RemoveDocumentModalProps> = ({
  show,
  onHide,
  document,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRemove = async () => {
    setLoading(true);
    setError(null);

    try {
      await removeDocument(document.id);
      onHide();
    } catch (error) {
      setError("Failed to remove the document. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const documentColumns = [
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      width: '30%',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const documentData = [
    { key: '1', field: 'Title', value: document.title },
    { key: '2', field: 'Added On', value: document.dateModified },
    { key: '3', field: 'User', value: document.user },
    { key: '4', field: 'Status', value: document.status },
  ];

  // Add metadata rows
  if (document.metadata && document.metadata.length > 0) {
    document.metadata.forEach((meta, index) => {
      documentData.push({
        key: `meta-${index}`,
        field: meta.key,
        value: meta.value,
      });
    });
  }

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f', marginRight: 8 }} />
          Document Details
        </span>
      }
      open={show}
      onCancel={onHide}
      footer={[
        <Button key="cancel" onClick={onHide} disabled={loading}>
          Cancel
        </Button>,
        <Button key="remove" type="primary" danger onClick={handleRemove} loading={loading}>
          Remove
        </Button>,
      ]}
      centered
      width={600}
    >
      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
      
      <Table
        columns={documentColumns}
        dataSource={documentData}
        pagination={false}
        bordered
        size="small"
      />
    </Modal>
  );
};

export default RemoveDocumentModal;
